import { Box, Breadcrumbs, Link, Paper, Typography } from "@mui/material";
import { TEI_WEB_URL } from "./../../config";
const accessToken = localStorage.getItem("accessToken");
let token
if (accessToken) {
   token = accessToken.replace(/"/g, "");
} else {
   token = "";
}
console.log(TEI_WEB_URL + `/register?token=${token}`)
const Reports = () => {
  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, mb: 2 }}>
        <Link underline="hover" color="inherit" href="/">
          หน้าแรก
        </Link>
        <Typography color="text.primary">เพิ่มสมาชิก</Typography>
      </Breadcrumbs>
      {/* <Typography component="h2" variant="h5" sx={{ mb: 2 }}>
        เพิ่มสมาชิก
      </Typography> */}

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper sx={{ height: "80vh" }}>
            <iframe
              src={TEI_WEB_URL + `/register?token=${token}`}
              style={{ width: "100%", height: "100%", border: "none" }}
              title="External Website"
            />
          </Paper>
        </Box>
      </Box>
    </div>
  );
};

export default Reports;
